import { InMemoryScrollingOptions, Routes } from '@angular/router';
import { canActivateWebAppLidskjalvGuard } from '@shared/router-guards/can-activate-web-app-lidskjalv.guard';
import { variableScaleLoaderResolver } from '@shared/resolvers/variable-scale-loader.resolver';
import {
  redirectLoggedInTo,
  redirectUnauthorizedTo,
} from '@shared/router-guards/auth.guard';
import { authenticatedDataLoaderCheckGuard } from '@shared/router-guards/authenticated-data-loader-check.guard';
import { restrictAccessToMobileDevicesResolver } from '@shared/resolvers/restrict-access-to-mobile-devices.resolver';
import { redirectFirstLoginOrPasswordResetCheckResolver } from '@shared/resolvers/redirect-first-login-or-password-reset-check.resolver';
import { userAccountActivationStatusCheckGuard } from '@shared/router-guards/user-account-activation-status-check.guard';

export const rootRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
    canActivate: [redirectLoggedInTo(['dashboard'])],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./pages/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    canActivate: [redirectUnauthorizedTo([''])],
  },
  {
    path: 'guides',
    loadChildren: () =>
      import('./pages/guides/guides.routes').then((m) => m.GUIDES_ROUTES),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/dashboard/dashboard.routes').then(
        (m) => m.DASHBOARD_ROUTES,
      ),
    canActivate: [
      redirectUnauthorizedTo(['']),
      authenticatedDataLoaderCheckGuard,
      userAccountActivationStatusCheckGuard,
      canActivateWebAppLidskjalvGuard,
    ],
    resolve: {
      restrictAccessToMobileDevicesResolver,
      areVariableScaleRangesLoaded: variableScaleLoaderResolver,
      redirectFirstLoginOrPasswordResetCheckResolver,
    },
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/sign-up-page/sign-up-page.component').then(
        (m) => m.SignUpPageComponent,
      ),
  },
  {
    path: 'sign-up/event-trial',
    loadComponent: () =>
      import('./pages/trial-signup-page/trial-signup-page.component').then(
        (m) => m.TrialSignupPageComponent,
      ),
  },
  {
    path: 'shared',
    loadChildren: () =>
      import('./pages/shared-page/shared.routes').then((m) => m.SHARED_ROUTES),
    resolve: {
      areVariableScaleRangesLoaded: variableScaleLoaderResolver,
    },
  },
  {
    path: '404',
    loadComponent: () =>
      import('./pages/page-not-found-page/page-not-found-page.component').then(
        (m) => m.PageNotFoundPageComponent,
      ),
  },
  {
    path: '**',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/page-not-found-page/page-not-found-page.component').then(
        (m) => m.PageNotFoundPageComponent,
      ),
  },
];

export const inMemoryScrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'enabled',
};
